module.exports = __webpack_public_path__ + "img/Les_donnees_modifier_sur_la_page.4358625a.png";